export const createUUID = () => {
  const startPosition = 2;
  const endPosition = 15;
  const randNum =
    Math.random().toString().slice(startPosition, endPosition) +
    Math.random().toString().slice(startPosition, endPosition);
  const date = Date.now().toString();
  return date + randNum;
};
